import React from "react";

import { FaRegCalendarAlt, FaMixer } from "react-icons/fa";
import { FaFileCircleCheck, FaFileCirclePlus, FaIdCard, FaUserSecret, FaUserLock } from "react-icons/fa6";
import TipoAtividade from "../../pages/dashboard/Administracao/TipoAtividade";
import DetailsTipoAtividade from "../../pages/dashboard/Administracao/TipoAtividade/Details";

const ChartSecretarias = React.lazy(() => import("../../pages/dashboard/Administracao/Chart"));
const ProducoesAprovadas = React.lazy(() => import("../../pages/dashboard/RHumanos/ProducoesAprovadas"));
const ProducaoNaoEnviado = React.lazy(() => import("../../pages/dashboard/RHumanos/ProducoesNaoEnviadas"));
const AuditoriaServidor = React.lazy(() => import("../../pages/dashboard/Auditoria/servidor"));
const AuditoriaSecretaria = React.lazy(() => import("../../pages/dashboard/Auditoria/secretaria"));
const Type = React.lazy(() => import("../../pages/dashboard/Auditoria/auditoria"));
const DataEnvio = React.lazy(() => import("../../pages/dashboard/RHumanos/DataEnvio"));
const Auditoria = React.lazy(() => import("../../pages/dashboard/Auditoria"));
const UsuariosGeral = React.lazy(() => import("../../pages/dashboard/Administracao/Usuarios"));
// const Relatorios = React.lazy(() => import("../../pages/dashboard/Relatorios"));
const DetailsPermissions = React.lazy(() => import("../../pages/dashboard/Administracao/Permissao/Details"));
const Permissao = React.lazy(() => import("../../pages/dashboard/Administracao/Permissao"));
const Usuario = React.lazy(() => import("../../pages/dashboard/RHumanos/Usuario/Details"));
const DetailsGrupo = React.lazy(() => import("../../pages/dashboard/RHumanos/Grupos/Details"));
const Grupos = React.lazy(() => import("../../pages/dashboard/RHumanos/Grupos"));
const DetailsFuncao = React.lazy(() => import("../../pages/dashboard/Administracao/Vinculos/DetailsFuncao"));
const DetailsCargo = React.lazy(() => import("../../pages/dashboard/Administracao/Vinculos/DetailsCargo"));
const Vinculos = React.lazy(() => import("../../pages/dashboard/Administracao/Vinculos"));
const DetailsSecretaria = React.lazy(() => import("../../pages/dashboard/Administracao/Secretarias/Details"));
const Secretaria = React.lazy(() => import("../../pages/dashboard/Administracao/Secretarias/Details/secretaria"));
const ProdCriar = React.lazy(() => import("../../pages/dashboard/Produtividade/Details"));
const Usuarios = React.lazy(() => import("../../pages/dashboard/RHumanos/Usuario"));
const Administracao = React.lazy(() => import("../../pages/dashboard/Administracao"));
const Leis = React.lazy(() => import("../../pages/dashboard/Administracao/Leis"));
const Lei = React.lazy(() => import("../../pages/dashboard/Administracao/Leis/Details"));
const Atividade = React.lazy(() => import("../../pages/dashboard/Administracao/Leis/Details/Atividade"));
const Secretarias = React.lazy(() => import("../../pages/dashboard/Administracao/Secretarias"));
const Atividades = React.lazy(() => import("../../pages/dashboard/Administracao/Atividades"));
const RHumanos = React.lazy(() => import("../../pages/dashboard/RHumanos"));
const Deliberacao = React.lazy(() => import("../../pages/dashboard/Deliberacao"));
const Produtividade = React.lazy(() => import("../../pages/dashboard/Produtividade"));

/*
 * Se não houver permissões informados na propriedade permissions,
 * a rota se torna publica a todos.
 */

export const privateRoutes = [

  /** ÁREA DO SERVIDOR */

  {
    path: "produtividades",
    title: "Produtividades",
    name: "Minhas produtividades",
    icon: FaFileCirclePlus,
    component: Produtividade,
    invisible: false,
    children: [
      {
        path: "produtividade/:id?",
        title: "Nova Produtividade",
        name: "Nova Produtividade",
        icon: FaRegCalendarAlt,
        component: ProdCriar,
        invisible: true,
        children: [],
        permissions: ["SERVIDOR"],
      }
    ],
    permissions: ["SERVIDOR"],
  },


  /** ÁREA DO CHEFE */

  {
    path: "chefia",
    title: "Deliberação",
    name: "Deliberação",
    icon: FaFileCircleCheck,
    component: Deliberacao,
    invisible: false,
    children: [],
    permissions: ["CHEFIA"],
  },

  /** ÁREA DO RECURSOS HUMANOS */


  {
    path: "recursos-humanos",
    title: "Recursos Humanos",
    name: "Recursos Humanos",
    icon: FaIdCard,
    component: RHumanos,
    invisible: false,
    children: [
      {
        path: "data-envio",
        title: "Data de Envio",
        name: "Data de Envio",
        icon: FaMixer,
        component: DataEnvio,
        invisible: true,
        children: [],
        permissions: ["RECURSOS_HUMANOS"],
      },
      {
        path: "producoes-aprovadas",
        title: "PRoduções Aprovadas",
        name: "PRoduções Aprovadas",
        icon: FaMixer,
        component: ProducoesAprovadas,
        invisible: true,
        children: [],
        permissions: ["RECURSOS_HUMANOS"],
      },
      {
        path: "producoes-nao-enviadas",
        title: "Data de Envio",
        name: "Data de Envio",
        icon: FaMixer,
        component: ProducaoNaoEnviado,
        invisible: true,
        children: [],
        permissions: ["RECURSOS_HUMANOS"],
      },
      {
        path: "usuarios",
        title: "Usuarios",
        name: "Usuarios",
        icon: FaMixer,
        component: Usuarios,
        invisible: true,
        children: [
          {
            path: "usuario/:id",
            title: "Usuario",
            name: "Usuario",
            icon: FaMixer,
            component: Usuario,
            invisible: true,
            children: [],
            permissions: ["RECURSOS_HUMANOS"],
          },
        ],
        permissions: ["RECURSOS_HUMANOS"],
      },
      {
        path: "grupos",
        title: "Grupos",
        name: "Grupos",
        icon: FaMixer,
        component: Grupos,
        invisible: true,
        children: [
          {
            path: "grupo/:id?",
            title: "Grupo",
            name: "Grupo",
            icon: FaMixer,
            component: DetailsGrupo,
            invisible: true,
            children: [],
            permissions: ["RECURSOS_HUMANOS"],
          },
        ],
        permissions: ["RECURSOS_HUMANOS"],
      },
    ],
    permissions: ["RECURSOS_HUMANOS"],
  },


  /** ÁREA DA ADMINISTRAÇÃO */


  {
    path: "administracao",
    title: "Administração",
    name: "Administração",
    icon: FaUserLock,
    component: Administracao,
    invisible: false,
    children: [
      {
        path: "chat",
        title: "Chat",
        name: "Chat",
        icon: FaMixer,
        component: ChartSecretarias,
        invisible: true,
        children: [],
        permissions: ["ADMINISTRADOR"],
      },
      {
        path: "usuarios",
        title: "Usuarios",
        name: "Usuarios",
        icon: FaMixer,
        component: UsuariosGeral,
        invisible: true,
        children: [],
        permissions: ["ADMINISTRADOR"],
      },
      {
        path: "permissoes",
        title: "Permissões",
        name: "Permissões",
        icon: FaMixer,
        component: Permissao,
        invisible: true,
        children: [
          {
            path: "permissao/:id",
            title: "Permissão",
            name: "Permissão",
            icon: FaMixer,
            component: DetailsPermissions,
            invisible: true,
            children: [],
            permissions: ["ADMINISTRADOR"],
          },
        ],
        permissions: ["ADMINISTRADOR"],
      },
      {
        path: "secretarias",
        title: "Secretarias",
        name: "Secretarias",
        icon: FaMixer,
        component: Secretarias,
        invisible: true,
        children: [
          {
            path: "secretaria",
            title: "Secretaria",
            name: "Secretaria",
            icon: FaMixer,
            component: Secretaria,
            invisible: true,
            children: [],
            permissions: ["ADMINISTRADOR"],
          },
          {
            path: "secretaria/:id",
            title: "Secretaria",
            name: "Secretaria",
            icon: FaMixer,
            component: DetailsSecretaria,
            invisible: true,
            children: [],
            permissions: ["ADMINISTRADOR"],
          },
        ],
        permissions: ["ADMINISTRADOR"],
      },
      {
        path: "atividades",
        title: "Atividades",
        name: "Atividades",
        icon: FaMixer,
        component: Atividades,
        invisible: true,
        children: [
          {
            path: "atividade/:idAtividade?",
            title: "Atividades",
            name: "Atividades",
            icon: FaMixer,
            component: Atividade,
            invisible: true,
            children: [],
            permissions: ["ADMINISTRADOR"],
          },
        ],
        permissions: ["ADMINISTRADOR"],
      },
      {
        path: "leis",
        title: "Leis",
        name: "Leis",
        icon: FaMixer,
        component: Leis,
        invisible: true,
        children: [
          {
            path: "lei/:id?",
            title: "Lei",
            name: "Lei",
            icon: FaMixer,
            component: Lei,
            invisible: true,
            children: [
              {
                path: "atividade/:idAtividade?",
                title: "Atividade",
                name: "Atividade",
                icon: FaMixer,
                component: Atividade,
                invisible: true,
                children: [],
                permissions: ["ADMINISTRADOR"],
              },
            ],
            permissions: ["ADMINISTRADOR"],
          }
        ],
        permissions: ["ADMINISTRADOR"],
      },
      {
        path: "vinculos",
        title: "Cargos e Funções",
        name: "Cargos e Funções",
        icon: FaMixer,
        component: Vinculos,
        invisible: true,
        children: [
          {
            path: "cargo/:id",
            title: "Cargo",
            name: "Cargo",
            icon: FaMixer,
            component: DetailsCargo,
            invisible: true,
            children: [],
            permissions: ["ADMINISTRADOR"],
          },
          {
            path: "funcao/:id",
            title: "Função",
            name: "Função",
            icon: FaMixer,
            component: DetailsFuncao,
            invisible: true,
            children: [],
            permissions: ["ADMINISTRADOR"],
          },
        ],
        permissions: ["ADMINISTRADOR"],
      },
      {
        path: "tipo-atividades",
        title: "Tipos de Atividades",
        name: "Tipos de Atividades",
        icon: FaMixer,
        component: TipoAtividade,
        invisible: true,
        children: [
          {
            path: "tipo-atividade/:id?",
            title: "Tipo de Atividade",
            name: "Tipo de Atividade",
            icon: FaMixer,
            component: DetailsTipoAtividade,
            invisible: true,
            children: [],
            permissions: ["ADMINISTRADOR"],
          }
        ],
        permissions: ["ADMINISTRADOR"],
      },
    ],
    permissions: ["ADMINISTRADOR"],
  },
  // {
  //   path: "relatorios",
  //   title: "Relatorio Mensal",
  //   name: "Relatorio Mensal",
  //   icon: FaFilePdf,
  //   component: Relatorios,
  //   invisible: false,
  //   children: [],
  //   permissions: ["CHEFIA", "RECURSOS_HUMANOS"],
  // },
  {
    path: "auditoria",
    title: "Auditoria",
    name: "Auditoria",
    icon: FaUserSecret,
    component: Auditoria,
    invisible: false,
    children: [
      {
        path: ":type/:id",
        title: "Auditoria",
        name: "Auditoria",
        icon: FaUserSecret,
        component: Type,
        invisible: false,
        children: [],
        permissions: ["ADMINISTRADOR"],
      },
      {
        path: "auditoria-servidor",
        title: "Auditoria",
        name: "Auditoria",
        icon: FaUserSecret,
        component: AuditoriaServidor,
        invisible: false,
        children: [],
        permissions: ["ADMINISTRADOR", "RECURSOS_HUMANOS"],
      },
      {
        path: "auditoria-secretaria",
        title: "Auditoria",
        name: "Auditoria",
        icon: FaUserSecret,
        component: AuditoriaSecretaria,
        invisible: false,
        children: [],
        permissions: ["ADMINISTRADOR"],
      }
    ],
    permissions: ["ADMINISTRADOR", "RECURSOS_HUMANOS"],
  }
];
